export const MODULE_NAME = 'Media';
